export const MAX_BUTTONS_ALLOWED = 2;
